import React from 'react';
import Carousel from '../components/Carousel';
import "./css/Gallery.css"
import floor from "../img/B block/Б Блок.png";
import floor1 from '../img/B block/0-02-08-ae1f9281f3b1a1118a77fb4e84d0f574344cade403b8300d8369d1980a44b332_8bfc1e76ce821712.jpg'
import floor2 from '../img/A block/0-02-08-e8c264243b1a1836101f2b1ec666584c29fc5d5d4cf2106eed1ba5c110e7e317_4f3095512f957cf2.jpg'
// import floor2 from '../img/fwdplanzurag80m2/2 floor B ail top 80m2 (2).jpg'
// import floor3 from '../img/fwdplanzurag80m2/2 floor B ail top 80m2 (3).jpg'

// import gallery1 from '../img/fwdplanzurag80m2/2floor B ail (1).jpg';
// import gallery2 from '../img/fwdplanzurag80m2/2floor B ail (2).jpg';
// import gallery3 from '../img/fwdplanzurag80m2/2floor B ail (3).jpg';
// import gallery4 from '../img/fwdplanzurag80m2/2floor B ail (4).jpg';
// import gallery5 from '../img/fwdplanzurag80m2/2floor B ail (5).jpg';
// import gallery6 from '../img/fwdplanzurag80m2/2floor B ail (6).jpg';
// import gallery7 from '../img/fwdplanzurag80m2/2floor B ail (7).jpg';
// import gallery8 from '../img/fwdplanzurag80m2/2floor B ail (8).jpg';
// import gallery9 from '../img/fwdplanzurag80m2/2floor B ail (9).jpg';
// import gallery10 from '../img/fwdplanzurag80m2/2floor B ail (10).jpg';
// import gallery11 from '../img/fwdplanzurag80m2/2floor B ail (11).jpg';
// import gallery12 from '../img/fwdplanzurag80m2/2floor B ail (12).jpg';
// import gallery13 from '../img/fwdplanzurag80m2/2floor B ail (13).jpg';

const galleryItems = [
    {
        id: 1,
        type: 'image' as const,
        src: floor || 'https://via.placeholder.com/1920x1080/2c4a63/ffffff?text=Gallery+2',
        alt: 'Floor image 1',
    },
    {
        id: 2,
        type: 'image' as const,
        src: floor1 || 'https://via.placeholder.com/1920x1080/2c4a63/ffffff?text=Gallery+2',
        alt: 'Floor image 1',
        // description: '1. Гал тогоо, зочны өрөө - 34.8м² \n2. Унтлагын өрөө - 10.86м² \n3. Унтлагын өрөө - 12.64м² \n4. Ариун цэврийн өрөө - 3.74м² \n5. Ариун цэврийн өрөө - 4.27м² \n6. Кродидор - 7.92м² \n7. Үүдний хэсэг - 3.52м² \n8. Тагт - 4.2м² ',
        // position: 'floor-plan'
    },
    {
        id: 3,
        type: 'image' as const,
        src: floor2 || 'https://via.placeholder.com/1920x1080/2c4a63/ffffff?text=Gallery+2',
        alt: 'Floor image 1',
    },

    // {
    //     id: 2,
    //     type: 'image' as const,
    //     src: gallery1 || 'https://placehold.co/600x400',
    //     alt: 'Gallery Image 1',
    //     description: '80м² - 3 өрөө сууц',
    //     position: 'top-right'
    // },
    // {
    //     id: 3,
    //     type: 'image' as const,
    //     src: gallery2 || 'https://via.placeholder.com/1920x1080/2c4a63/ffffff?text=Gallery+2',
    //     alt: 'Gallery Image 2',
    //     description: '80м² - 3 өрөө сууц',
    //     position: 'top-right'
    // },
    // {
    //     id: 4,
    //     type: 'image' as const,
    //     src: gallery3 || 'https://via.placeholder.com/1920x1080/1a2f3f/ffffff?text=Gallery+3',
    //     alt: 'Gallery Image 8',
    //     description: '80м² - 3 өрөө сууц',
    //     position: 'top-right'
    // },
    // {
    //     id: 5,
    //     type: 'image' as const,
    //     src: gallery4 || 'https://via.placeholder.com/1920x1080/2c4a63/ffffff?text=Gallery+4',
    //     alt: 'Gallery Image 4',
    //     description: '80м² - 3 өрөө сууц',
    //     position: 'top-right'
    // },
    // {
    //     id: 6,
    //     type: 'image' as const,
    //     src: gallery5 || 'https://via.placeholder.com/1920x1080/1a2f3f/ffffff?text=Gallery+5',
    //     alt: 'Gallery Image 5',
    //     description: '80м² - 3 өрөө сууц',
    //     position: 'top-right'
    // },
    // {
    //     id: 7,
    //     type: 'image' as const,
    //     src: gallery6 || 'https://via.placeholder.com/1920x1080/1a2f3f/ffffff?text=Gallery+3',
    //     alt: 'Gallery Image 6',
    //     description: '80м² - 3 өрөө сууц',
    //     position: 'top-right',
    // },
    // {
    //     id: 8,
    //     type: 'image' as const,
    //     src: gallery7 || 'https://via.placeholder.com/1920x1080/1a2f3f/ffffff?text=Gallery+3',
    //     alt: 'Gallery Image 7',
    //     description: '80м² - 3 өрөө сууц',
    //     position: 'top-right'
    // },
    // {
    //     id: 9,
    //     type: 'image' as const,
    //     src: gallery8 || 'https://via.placeholder.com/1920x1080/1a2f3f/ffffff?text=Gallery+3',
    //     alt: 'Gallery Image 8',
    //     description: '80м² - 3 өрөө сууц',
    //     position: 'top-right'
    // },
    // {
    //     id: 10,
    //     type: 'image' as const,
    //     src: gallery9 || 'https://via.placeholder.com/1920x1080/1a2f3f/ffffff?text=Gallery+3',
    //     alt: 'Gallery Image 9',
    //     description: '80м² - 3 өрөө сууц',
    //     position: 'top-right',
    // },
    // {
    //     id: 11,
    //     type: 'image' as const,
    //     src: gallery10 || 'https://via.placeholder.com/1920x1080/1a2f3f/ffffff?text=Gallery+3',
    //     alt: 'Gallery Image 10',
    //     description: '80м² - 3 өрөө сууц',
    //     position: 'top-right'
    // },
    // {
    //     id: 12,
    //     type: 'image' as const,
    //     src: gallery11 || 'https://via.placeholder.com/1920x1080/1a2f3f/ffffff?text=Gallery+3',
    //     alt: 'Gallery Image 11',
    //     description: '80м² - 3 өрөө сууц',
    //     position: 'top-right'
    // },
    // {
    //     id: 13,
    //     type: 'image' as const,
    //     src: gallery12 || 'https://via.placeholder.com/1920x1080/1a2f3f/ffffff?text=Gallery+3',
    //     alt: 'Gallery Image 12',
    //     description: '80м² - 3 өрөө сууц',
    //     position: 'top-right',
    // },
    // {
    //     id: 14,
    //     type: 'image' as const,
    //     src: gallery13 || 'https://via.placeholder.com/1920x1080/1a2f3f/ffffff?text=Gallery+3',
    //     alt: 'Gallery Image 13',
    //     description: '80м² - 3 өрөө сууц',
    //     position: 'top-right'
    // },

];

const Gallery2: React.FC = () => {
    return (
        <div className="gallery-page">
            <Carousel
                items={galleryItems}
                autoPlay={true}
                autoPlayInterval={6000}
            />
        </div>
    );
};

export default Gallery2;